<template>
    <div class="container">
        <div class="section">
            <img class="img" src="https://lagou-zhaopin-fe.lagou.com/jiaoyu/growth/business/pc/1%402x.png">
        </div>
        <div class="section">
            <img class="img" src="https://s20.lgstatic.com/growth/activity/20220713/1657693918606.png">
        </div>
        <div class="section">
            <img class="img" src="https://s21.lgstatic.com/growth/activity/20220713/1657693926354.png">
        </div>
        <div class="section">
            <img class="img" src="https://s21.lgstatic.com/growth/activity/20220713/1657693936723.png">
        </div>
        <div class="section">
            <img class="img" src="https://s21.lgstatic.com/growth/activity/20220713/1657693944302.png">
        </div>
        <div class="sectione-main">
            <div class="main">
                <el-tabs v-model="activeName" @tab-click="changeTabs">
                    <el-tab-pane class="main-tab"
                        v-for="(item, index) in stageList" :key="index"
                        :label="item.stage" :name="index"
                    >
                        <div class="m">
                            <div class="m-title">
                                {{item.title}}
                            </div>
                            <img class="main-icon" src="https://s21.lgstatic.com/growth/activity/20210402/1617345169076.png">
                            <div class="main-t">
                                <div class="m-b">
                                    学习目标
                                </div>
                            </div>
                            <div class="item" v-for="(v, i) in item.phaseTargetList" :key="i" > {{v}}</div>
                            <div class="main-t">
                                <div class="m-b">
                                    核心内容
                                </div>
                            </div>
                            <div class="item" v-for="(v, i) in item.skillsList" :key="i" > {{v}}</div>
                            <div v-if="item.skillsContent.length" class="main-t">
                                <div class="m-b">
                                    核心技术
                                </div>
                            </div>
                            <template v-if="item.skillsContent.length">
                                <div class="item" v-for="(v, i) in item.skillsContent" :key="i" > {{v}}</div>
                            </template>
                        </div>
                    </el-tab-pane>
                </el-tabs>
                <div class="modal" v-if="showModal">
                    <img @click="close" class="close" src="https://s21.lgstatic.com/growth/activity/20210412/1618215171460.png">
                    <div v-for="(item, index) in showData.details" :key="index">
                        <div class="modal-title">
                            {{item.t}}
                        </div>
                        <div class="modal-desc" v-for="(i, is) in item.desc" :key="is">
                            {{i}}
                        </div>
                    </div>
                </div>
                <div class="tips-tab">
                    * 具体课程内容以实际课程安排和进度为准
                </div>
                <button class="jump-btn" @click="JumpFn('领取完整课程安排')">
                    <img src="https://s20.lgstatic.com/growth/activity/20220713/1657694997890.png">
                </button>
            </div>
        </div>
        <div class="sectione-main sectione-main2">
            <img class="img" src="https://s20.lgstatic.com/growth/activity/20220713/1657694142674.png">
            <div class="main">
                <el-tabs v-model="activeName2">
                    <el-tab-pane class="main-tab"
                        v-for="(item, index) in projectsDetail" :key="index"
                        :label="item.title" :name="index"
                    >
                        <div class="m">
                            <div class="m-title">
                                {{item.projectTitle}}
                            </div>
                            <img class="main-icon" src="https://s21.lgstatic.com/growth/activity/20210402/1617345169076.png">
                            <template v-for="(detail, k) in item.details">
                                <div :key="k">
                                    <div class="main-t">
                                        <div class="m-b">
                                            {{ detail.title }}
                                        </div>
                                    </div>
                                    <div v-if="detail.txt" class="item">{{ detail.txt }}</div>
                                    <template v-if="detail.txts && detail.txts.length">
                                        <div v-for="(txt, m) in detail.txts" :key="m" class="item">{{ txt }}</div>
                                    </template>
                                </div>
                            </template>
                            <div class="project-img-wrap">
                                <img class="project-img" v-for="(img, j) in item.projectImgs" :key="j" :src="img">
                            </div>
                        </div>
                    </el-tab-pane>
                </el-tabs>
                <button class="jump-btn jump-btn2" @click="JumpFn('获取更多项目资料')">
                    <img src="https://s20.lgstatic.com/growth/activity/20220713/1657695028184.png">
                </button>
            </div>
        </div>
        <!-- <div class="section">
            <img class="img" src="https://s21.lgstatic.com/growth/activity/20220713/1657694260637.png">
        </div> -->

        <button class="footer" @click="JumpFn('名额有限立即抢占')">
          <img style="width: 100%;" src="https://lagou-zhaopin-fe.lagou.com/jiaoyu/growth/business/pc/%E5%90%B8%E5%BA%95%402x.png"
               alt="">
        </button>
    </div>
</template>

<script>
import Swiper from 'swiper';
import 'swiper/dist/css/swiper.css';
import { handleJumpUrl } from '../../../uitl/getParam.js';
import List from './data.js'
import activity from '../../../common/activity';
import mixin from '../../../common/js/mixins/repurchase'

export default {
    name: 'SignIn',
    mixins: [mixin],
    data() {
        return {
            activity,
            courseId: 82,
            List,
            imgObj:{},
            imgList:[],
            imgList1:[],
            swiperList:[],
            swiperList1:[],
            swiperList2:[],
            swiperList3:[],
            tabList:[],
            stageList:[],
            activeTab:0,
            ceilingType:false,//吸顶tab
            showData:{},
            showModal:false,
            projectsDetail: [],
            swiperListNew: [
                "https://s21.lgstatic.com/growth/activity/20220705/1657010137201.png",
                "https://s21.lgstatic.com/growth/activity/20220705/1657010160133.png",
                "https://s20.lgstatic.com/growth/activity/20220705/1657010168696.png",
                "https://s21.lgstatic.com/growth/activity/20220705/1657010177271.png"
            ],
            addressIdsMap: {
                "领取完整课程安排": "u1tz1",
                "获取更多项目资料": "v1tz2",
                "名额有限立即抢占": "w1tz3"
            }
        };
    },
    mounted() {
        let dataList = this.List.data.pc
        this.imgObj = dataList.imgObj
        this.imgList = dataList.imgList
        this.imgList1 = dataList.imgList1

        this.swiperList = dataList.swiperList
        this.swiperList1 = dataList.swiperList1
        this.swiperList2 = dataList.swiperList2
        this.swiperList3 = dataList.swiperList3

        this.tabList = this.List.data.tabList
        this.stageList = this.List.data.stageList
        this.projectsDetail = this.List.data.projectsDetail
        // setTimeout(()=>{
        //     if(this.isAB) {
        //         this.eduPlatTrack('WebView', { page_id: '1qb3', 'page_from':'大课学习页'});
        //     } else {
        //         this.eduPlatTrack('WebView', { page_id: '1qb3'});
        //     }
        //     this.swiperInit()
        //     this.renderSwiper2()
        // },500)
        // window.addEventListener('scroll', this.scrollTopFn)
        setTimeout(() => {
            this.platTrack('pcpv', {
                page_id: 'e1tyk',
            })
        }, 500);
    },
    destroyed () {
        // window.removeEventListener('scroll', this.scrollTopFn)
    },
    methods: {
        changeTab(item,index) {
            this.activeTab = index
            let arr = [
                "#section_01",
                "#section_1",
                "#section_3",
                "#section_tab",
                "#img_0"
            ]
            this.$el.querySelector(arr[index]).scrollIntoView(true);
            let scroll = document.documentElement.scrollTop || document.body.scrollTop;
            document.documentElement.scrollTop = scroll - 100
            document.body.scrollTop = scroll - 100
            // this.eduPlatTrack('WebButtonClick', {
            //     'page_id': '1qb3',
            //     'button_name': item.stage
            // });
            this.platTrackClickFn(item.stage);
        },
        scrollTopFn() {
            let scroll = document.documentElement.scrollTop || document.body.scrollTop;
            console.log(scroll);
            this.ceilingType = scroll > 550 ? true : false; //吸顶tab
            let arr = [
                "section_01",
                "section_1",
                "section_3",
                "section_tab",
                "img_0"
            ]
            arr.forEach((item,index) =>{
                if(document.getElementById(item).getBoundingClientRect().top < 200) {
                    this.activeTab = index
                }
            })
        },
        JumpFn(str) {
            // if(this.showNew) {
            //     this.eduPlatTrack('WebButtonClick', {
            //         'page_id': '1qb3',
            //         'courses_id':[this.courseId+''],
            //         'button_name': '试学申请'
            //     });
            // } else {
            //     this.eduPlatTrack('WebButtonClick', {
            //         'page_id': '1qb3',
            //         'button_name':  '领取成长路线图'
            //     });
            // }
            str && this.platTrackClickFn(str);
            setTimeout(() => {
                handleJumpUrl('ed1890dd539543ef9f01d38018e5d3d0');
            }, 200);
        },
        swiperInit() {
            let option = {
                direction: 'horizontal',
                loop: true,
                speed: 1400,
                autoplayDisableOnInteraction: false,
                autoplay: 2000,
                spaceBetween: 30,
                pagination: '.current-pagination',
            };
            let option1 = {
                direction: 'horizontal',
                loop: true,
                speed: 500,
                autoplayDisableOnInteraction: false,
                autoplay: 3000,
                pagination: '.sw-pagination',
                paginationClickable: true,
                prevButton: '.swiper-button-prev',
                nextButton: '.swiper-button-next',
                spaceBetween: 30
            };
            this.$nextTick(() => {
                const swiper = new Swiper('.current-wrap', option);
                const swiper1 = new Swiper('.current', option);
                const swiper2 = new Swiper('.sw-wrap', option1);

            });
        },
        seeDetail(val) {
            this.showModal = true;
            this.showData = val
        },
        close() {
            this.showModal = false;
        },
        changeTabs(val) {
            this.showModal = false
        },
        renderSwiper() {
            setTimeout(() => {
                let modify = 0;
                let translate = 0;
                let scale = 0;
                const swiper = new Swiper('.wrap', {
                    autoplay: 3000,
                    loop: true,
                    slidesPerView: 'auto',
                    loopedSlides: 4,
                    pagination: '.sw-pagination',
                    paginationClickable: true,
                    watchSlidesProgress: true,
                    // prevButton: '.swiper-button-prev',
                    // nextButton: '.swiper-button-next',
                    centeredSlides: true,
                    onSetTransition: (swiper, transition) => {
                        for (let i = 0; i < swiper.slides.length; i++) {
                            let slide = swiper.slides.eq(i);
                            slide.transition(transition);
                        }
                    },
                });

                swiper.on('progress', () => {
                    for (let i = 0; i < swiper.slides.length; i++) {
                        let slide = swiper.slides.eq(i);
                        let slideProgress = swiper.slides[i].progress;
                        modify = 1;
                        if (Math.abs(slideProgress) > 1) {
                            modify = (Math.abs(slideProgress) - 1) * 0.3 + 1;
                        }
                        translate = slideProgress * modify * 300 + 'PX';
                        scale = 1 - Math.abs(slideProgress) / 5;
                        let zIndex = 999 - Math.abs(Math.round(10 * slideProgress));
                        slide.transform('translateX(' + translate + ') scale(' + scale + ')');
                        slide.css('zIndex', zIndex);
                    }
                });
            }, 500);
        },
        renderSwiper2() {
            setTimeout(() => {
                let modify = 0;
                let translate = 0;
                let scale = 0;
                const swiper = new Swiper('.sw-wrap', {
                    autoplay: 3000,
                    loop: true,
                    slidesPerView: 'auto',
                    loopedSlides: 4,
                    pagination: '.sw-pagination',
                    paginationClickable: true,
                    watchSlidesProgress: true,
                    prevButton: '.swiper-button-prev',
                    nextButton: '.swiper-button-next',
                    centeredSlides: true,
                    onSetTransition: (swiper, transition) => {
                        for (let i = 0; i < swiper.slides.length; i++) {
                            let slide = swiper.slides.eq(i);
                            slide.transition(transition);
                        }
                    },
                });

                swiper.on('progress', () => {
                    for (let i = 0; i < swiper.slides.length; i++) {
                        let slide = swiper.slides.eq(i);
                        let slideProgress = swiper.slides[i].progress;
                        modify = 1;
                        if (Math.abs(slideProgress) > 1) {
                            modify = (Math.abs(slideProgress) - 1) * 0.3 + 1;
                        }
                        translate = slideProgress * modify * 600 + 'PX';
                        scale = 1 - Math.abs(slideProgress) / 5;
                        let zIndex = 999 - Math.abs(Math.round(10 * slideProgress));
                        slide.transform('translateX(' + translate + ') scale(' + scale + ')');
                        slide.css('zIndex', zIndex);
                    }
                });
            }, 500);
        },
        platTrackClickFn(name) {
            this.platTrack('pcclick', {
                page_id: 'e1tyk',
                address_id: this.addressIdsMap[name]
            })
        }
    }
};
</script>

<style lang='less' scoped>
.container {
    width: 100%;
    min-width: 1200PX;
    background: #F4F4F4;
    padding-bottom: 100PX;
    .section {
        position: relative;
        width: 100%;
        min-width: 1200PX;
        &.section-sw {
            height: 813PX;
            background-color: #1C8AEE;
            overflow: hidden;
            .img {
                display: block;
                width: 850PX;
                margin: 60PX auto 0;
            }
            /deep/ .sw-wrap {
                position: absolute;
                top: 360PX;
                left: 50%;
                transform: translate(-50%);
                width: 1100PX;
                height: 400PX;
                .swiper-slide {
                    width: 782PX;
                    opacity: 0;
                    img {
                        display: block;
                        width: 782PX;
                        margin: 0 auto;
                    }
                    &.swiper-slide-active {
                        opacity: 1;
                    }
                    &.swiper-slide-next, &.swiper-slide-prev {
                        opacity: .5;
                    }
                }
                .swiper-pagination {
                    bottom: 0PX;
                }
                .swiper-pagination-bullet{
                    width: 10PX;
                    height: 10PX;
                    background: linear-gradient(90deg, #fff 0%, #fff 100%);
                    border-radius: 50%;
                    opacity: .5;
                    &-active{
                        opacity: 1;
                        border-radius: 10PX;
                        width: 22PX;
                        background: linear-gradient(90deg, #fff 0%, #fff 100%);
                    }
                }
                .swiper-button-prev {
                    background: url('https://s21.lgstatic.com/growth/activity/20210402/1617354468162.png') no-repeat center;
                    background-size: 100% 100%;
                    width: 58PX;
                    height: 58PX;
                    top: 50%;
                    transform: translateY(-50%);
                    left: 0PX;
                }
                .swiper-button-next {
                    background: url('https://s21.lgstatic.com/growth/activity/20210402/1617354439579.png') no-repeat center;
                    background-size: 100% 100%;
                    width: 58PX;
                    height: 58PX;
                    right: -80PX;
                    top: 50%;
                    transform: translateY(-50%);
                    right: 0PX;
                }
            }
        }
        .img {
            width: 100%;
            display: block;
        }
        .activityBox {
            position: absolute;
            top: 0;
            left: 50%;
            transform: translate(-50%);
            width: 1000PX;
            height: 150PX;
        }
        .activityImg {
            display: block;
            float: right;
            width: 104PX;
            height: 133PX;
        }
    }
    .ceiling-view {
        width: 100%;
        height: 66PX;
        margin: 0PX auto 40PX;
        background-color: #fff;
        .ceiling-tab {
            width: 1100PX;
            margin: 0 auto;
            height: 66PX;
            background-color: #fff;
            border-radius: 2PX;
            box-shadow: 0PX 6PX 8PX 0PX rgba(214, 209, 250, 0.08);
            display: flex;
            align-items: center;
            cursor: pointer;
            // transform: scale(.7);
            .tab-item {
                position: relative;
                flex: 1;
                text-align: center;
                font-size: 20PX;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #32355C;
                height: 100%;
                line-height: 66PX;
                box-sizing: border-box;
                .bor {
                    position: absolute;
                    bottom: 0;
                    left: 50%;
                    transform: translate(-50%);
                    width: 168PX;
                    height: 3PX;
                    border-radius: 1PX;
                    background: linear-gradient(293deg, #58BEFF 0%, #1573EB 100%);
                }
            }
            .active-tab {
                box-sizing: border-box;
                padding-left: 40PX;
                &::before{
                    content: '';
                    width: 24PX;
                    height: 24PX;
                    background: url('https://s20.lgstatic.com/growth/activity/20210915/1631674560435.png') no-repeat center;
                    background-size: 100% 100%;
                    position: absolute;
                    left: 62PX;
                    top:50%;
                    transform: translateY(-50%);
                    transition-duration: 0.3s;
                }
            }

        }
        @media screen and (max-width:1900px){
            .ceiling-tab {
                width: 940PX;
                .tab-item {
                    .bor {
                        width: 148PX;
                    }
                }
                .active-tab {
                    padding-left: 40PX;
                    &::before{
                        left: 44PX;
                    }
                }
            }
        }
        @media screen and (max-width:1500px){
            .ceiling-tab {
                width: 790PX;
                .tab-item {
                    .bor {
                        width: 140PX;
                    }
                }
                .active-tab {
                    padding-left: 30PX;
                    &::before{
                        left: 26PX;
                    }
                }
            }
        }

    }
    .ceiling-fixed {
        position: fixed;
        top: 0;
        left: 50%;
        transform: translate(-50%);
        z-index: 30;
    }
    .sw-section-1 {
        position: relative;
        width: 100%;
        min-width: 1200PX;
        .img {
            width: 100%;
            display: block;
        }
        .icon {
            width: 900PX;
            height: 40PX;
            margin: 0 auto;
            img {
               width: 200PX;
               display: block;
               float: right;
            }
        }

        /deep/ .current {
            width: 900PX;
            margin: 20PX auto 0;
            padding-bottom: 30PX;
            .swiper-slide {
                width: 900PX;
                img {
                    display: block;
                    margin: 0 auto;
                    width: 900PX;
                }
            }
            .swiper-pagination {
                bottom: 0PX;
            }
            .swiper-pagination-bullet{
                width: 10PX;
                height: 10PX;
                background: linear-gradient(181deg, #FFB317 0%, #FF613A 100%) linear-gradient(270deg, #25168F 0%, #25106E 100%);
                border-radius: 50%;
                opacity: .4;
                &-active{
                    border-radius: 10PX;
                    width: 22PX;
                    background: linear-gradient(181deg, #FFB317 0%, #FF613A 100%) linear-gradient(270deg, #25168F 0%, #25106E 100%);
                    opacity: 1;
                }
            }
        }
    }
    .sw-section {
        width: 1200PX;
        margin: 0 auto;
        /deep/ .sw-wrap {
            width: 1000PX;
            padding-bottom: 30PX;
            .swiper-slide {
                width: 900PX;
                img {
                    display: block;
                    margin: 0 auto;
                    width: 900PX;
                }
            }
            .swiper-pagination {
                bottom: 0PX;
            }
            .swiper-pagination-bullet{
                width: 10PX;
                height: 10PX;
                background: linear-gradient(181deg, #FFB317 0%, #FF613A 100%) linear-gradient(270deg, #25168F 0%, #25106E 100%);
                border-radius: 50%;
                opacity: .4;
                &-active{
                    border-radius: 10PX;
                    width: 22PX;
                    background: linear-gradient(181deg, #FFB317 0%, #FF613A 100%) linear-gradient(270deg, #25168F 0%, #25106E 100%);
                    opacity: 1;
                }
            }
            .swiper-button-prev {
                background: url('https://s21.lgstatic.com/growth/activity/20210916/1631778240973.png') no-repeat center;
                background-size: 100% 100%;
                width: 16PX;
                height: 32PX;
            }
            .swiper-button-next {
                background: url('https://s21.lgstatic.com/growth/activity/20210916/1631778231186.png') no-repeat center;
                background-size: 100% 100%;
                width: 16PX;
                height: 32PX;
            }
        }
    }
    .sectione-main {
        width: 100%;
        min-width: 1100PX;
        margin-bottom: 100PX;
        position: relative;

        .main {
            position: relative;
            width: 1100PX;
            margin: 0 auto;
            border-radius: 16PX;
            background-color: #fff;
            // padding-bottom: 100PX;
            .tips-tab {
                font-size: 14PX;
                color: rgba(61, 62, 99, .3);
                position: absolute;
                bottom: 80PX;
                left: 0;
                width: 100%;
                text-align: center;
            }
            .tips-tab2 {
                bottom: 10PX;
            }
            .m {
                width: 100%;
                box-sizing: border-box;
                padding: 0 65PX 140PX;
            }
            .m-title {
                padding-top: 30PX;
                font-size: 28PX;
                font-family: SourceHanSansSC-Medium, SourceHanSansSC;
                font-weight: 400;
                color: #6469A7;
                text-align: center;
            }
            .main-icon {
                width: 688PX;
                height: 2PX;
                display: block;
                margin: 8PX auto 0;
            }
            .main-t {
                width: 100%;
                height: 50PX;
                padding-top: 35PX;
                margin-bottom: 20PX;
                .m-b {
                    float: left;
                    width: 166PX;
                    height: 46PX;
                    font-size: 24PX;
                    text-align: center;
                    line-height: 46PX;
                    border-radius: 50PX;
                    color: #6469A7;
                    background: linear-gradient(192deg, rgba(99, 137, 255, .1) 0%, rgba(108, 101, 255, .1) 100%);
                }
                .detail {
                    display: block;
                    width: 132PX;
                    height: 48PX;
                    float: right;
                }
            }
            .item {
                position: relative;
                font-size: 20PX;
                font-family: SourceHanSansSC-Light, SourceHanSansSC;
                color: #6469A7;
                margin: 10PX 20PX;
                padding-left: 15PX;
                &::after {
                    position: absolute;
                    content: '';
                    left: 0PX;
                    top: 50%;
                    transform: translateY(-50%);
                    width: 6PX;
                    height: 6PX;
                    border-radius: 50%;
                    background: #6469A7;
                }
            }
            .modal {
                position: absolute;
                top: 190PX;
                left: 50%;
                transform: translate(-50%);
                width: 1100PX;
                border-radius: 16PX;
                background-color: #fefefe;
                z-index: 999;
                border: 2PX solid #6469A7;
                box-sizing: border-box;
                padding: 20PX 50PX 40PX;
                .close {
                    position: absolute;
                    right: 14PX;
                    top: 14PX;
                    width: 40PX;
                    height: 40PX;
                }
                .modal-title {
                    font-size: 20PX;
                    padding:35PX 0 10PX;
                    color: #6469A7;
                }
                .modal-desc {
                    font-size: 18PX;
                    color: #6469A7;
                    padding-left: 18PX;
                }
            }
            .jump-btn {
                position: absolute;
                left: 50%;
                transform: translate(-50%);
                bottom: -24PX;
                width: 408PX;
                height: 68PX;
                background-color:transparent;
                border: none;
                img {
                    width: 100%;
                    display: block;
                }
            }
            .jump-btn2 {
                bottom: -32PX;
            }
        }
        .project-img {
            width: 50%;
            vertical-align: top;
        }
        /deep/ .el-tabs {
            width: 1100PX;
            margin: 30PX auto 0PX;
            .el-tabs__header, .el-tabs__nav-wrap, .el-tabs__nav-scroll {
                height: 96PX;
                border-top-left-radius: 16PX;
                border-top-right-radius: 16PX;
                background-image: linear-gradient(-79deg, #04B39A 7%, #13DABC 100%);
            }
            .el-tabs__item {
                line-height: 96PX;
                text-align: center;
                width: 140PX;
                height: 96PX;
                padding: 0;
                font-size: 22PX;
                font-family: SourceHanSansSC-Regular, SourceHanSansSC;
                color: #fff;
                font-weight: normal;
                &:hover {
                    color: #eee;
                }
            }
            .el-tabs__nav-prev {
                top: 50%;
                color: #fff;
                font-weight: 500;
                font-size: 34PX;
                transform: translateY(-50%);
            }
            .el-tabs__nav-wrap.is-scrollable {
                padding: 0 35PX;
            }
            .el-tabs__nav-next {
                top: 50%;
                color: #fff;
                font-weight: 500;
                font-size: 34PX;
                transform: translateY(-50%);
            }
            .el-tabs__nav-wrap::after{
                background-color: transparent;
            }
            .el-tabs__active-bar {
                background-color: transparent;
            }
            .el-tabs__item.is-active {
                color: #fff;
                font-weight: bold;
                font-size: 25PX;
            }
        }
        &.sectione-main2 {
            margin-bottom: 60PX;
            .main {
                .m {
                    width: 100%;
                    box-sizing: border-box;
                    padding: 0 65PX 40PX;
                }
            }
            .img {
                display: block;
                width: 585PX;
                margin: 0 auto;
            }
            /deep/ .el-tabs {
                width: 1100PX;
                margin: 30PX auto 0PX;
                .el-tabs__header, .el-tabs__nav-wrap, .el-tabs__nav-scroll {
                    height: 96PX;
                    border-top-left-radius: 16PX;
                    border-top-right-radius: 16PX;
                    background-image: linear-gradient(-79deg, #04B39A 7%, #13DABC 100%);
                }
                .el-tabs__item {
                    line-height: 96PX;
                    text-align: center;
                    width: 360PX;
                    height: 96PX;
                    padding: 0;
                    font-size: 22PX;
                    font-family: SourceHanSansSC-Regular, SourceHanSansSC;
                    color: #fff;
                    font-weight: normal;
                    &:hover {
                        color: #eee;
                    }
                }
                .el-tabs__nav-prev {
                    top: 50%;
                    color: #fff;
                    font-weight: 500;
                    font-size: 34PX;
                    transform: translateY(-50%);
                }
                .el-tabs__nav-wrap.is-scrollable {
                    padding: 0 35PX;
                }
                .el-tabs__nav-next {
                    top: 50%;
                    color: #fff;
                    font-weight: 500;
                    font-size: 34PX;
                    transform: translateY(-50%);
                }
                .el-tabs__nav-wrap::after{
                    background-color: transparent;
                }
                .el-tabs__active-bar {
                    background-color: transparent;
                }
                .el-tabs__item.is-active {
                    color: #fff;
                    font-weight: bold;
                    font-size: 25PX;
                }
            }
        }
    }
    .sw-section-2 {
        width: 100%;
        background-color: #1C8AEE;
        padding-bottom: 60PX;
        /deep/ .current-wrap {
            width: 900PX;
            margin: 0 auto;
            padding-bottom: 30PX;
            .swiper-slide {
                width: 900PX;
                img {
                    display: block;
                    margin: 0 auto;
                    width: 900PX;
                }
            }
            .swiper-pagination {
                bottom: 0PX;
            }
            .swiper-pagination-bullet{
                width: 10PX;
                height: 10PX;
                background: #2747C2;
                border-radius: 50%;
                opacity: .6;
                &-active{
                    border-radius: 10PX;
                    width: 22PX;
                    background: #FFFFFF;
                    opacity: 1;
                }
            }
        }
        .sw-btn {
            display: block;
            margin: 60PX auto 0;
            width: 408PX;
            height: 68PX;
            background-color:transparent;
            border: none;
            img {
                width: 100%;
                display: block;
            }
        }
    }
    .sw-section-3 {
        width: 100%;
        background-color: #1C8AEE;
        padding: 30PX 0 100PX;
        .logo {
            width: 100%;
            display: block;
        }
        /deep/ .wrap {
            width: 900PX;
            height: 220PX;
            .swiper-slide {
                width: 540PX;
                opacity: 0;
                img {
                    display: block;
                    width: 540PX;
                    margin: 0 auto;
                }
                &.swiper-slide-active {
                    opacity: 1;
                }
                &.swiper-slide-next, &.swiper-slide-prev {
                    opacity: .5;
                }
            }
            .swiper-pagination {
                bottom: 0PX;
            }
            .swiper-pagination-bullet{
                width: 10PX;
                height: 10PX;
                background: linear-gradient(90deg, #fff 0%, #fff 100%);
                border-radius: 50%;
                opacity: .5;
                &-active{
                    opacity: 1;
                    border-radius: 10PX;
                    width: 22PX;
                    background: linear-gradient(90deg, #fff 0%, #fff 100%);
                }
            }
            // .swiper-button-prev {
            //     background: url('https://s21.lgstatic.com/growth/activity/20210402/1617354468162.png') no-repeat center;
            //     background-size: 100% 100%;
            //     width: 58PX;
            //     height: 58PX;
            //     top: 50%;
            //     transform: translateY(-50%);
            //     left: 0PX;
            // }
            // .swiper-button-next {
            //     background: url('https://s21.lgstatic.com/growth/activity/20210402/1617354439579.png') no-repeat center;
            //     background-size: 100% 100%;
            //     width: 58PX;
            //     height: 58PX;
            //     right: -80PX;
            //     top: 50%;
            //     transform: translateY(-50%);
            //     right: 0PX;
            // }
        }
    }
    .footer {
        position: fixed;
        background-color:transparent;
        border: none;
        bottom: 0PX;
        height: 130PX;
        left: 50%;
        transform: translate(-50%);
        z-index: 999;
        width: 100%;
        box-shadow: 0PX -12PX 12PX 0PX rgba(156, 157, 185, 0.22);
      .box {
        width: 100%;
        .box-inner {
          position: relative;
          width: 1200PX;
          height: 100%;
          margin: 0 auto;
          overflow: hidden;
        }
        &-fixed {
          position: fixed;
          bottom: 0;
          left: 0;
          height: 118PX;
          line-height: 118PX;
          background-color: #fff;
          z-index: 999;
        }
      }
      .box10-content {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .box10-left {
          display: flex;
          align-items: center;
          color: #333;
          font-size: 26PX;
          & > img {
            width: 24PX;
            height: 24PX;
            margin-right: 12PX;
          }
        }
        .box10-right {
          width: 384PX;
          height: 68PX;
          line-height: 68PX;
          background: linear-gradient(90deg, #FF5487 0%, #FF854C 100%);
          border-radius: 39PX;
          font-size: 24PX;
          color: #fff;
          text-align: center;
        }
      }
        .img {
            width: 100%;
            display: block;
        }
        .iconBox {
            position: absolute;
            top: -30PX;
            left: 50%;
            transform: translate(-50%);
            z-index: 9999;
            width: 1000PX;
            .icon {
                float: right;
                width: 134PX;
            }
        }
        .img {
            width: 100%;
            display: block;
        }
        .text-loop {
          position: absolute;
          width: 215PX;
          height: 37PX;
          right: 31.5%;
          top: 50%;
          transform: translateY(-50%);
          border: none;
          border-image-width: 0;
        }
    }
}
.section-title {
    font-family: SourceHanSansCN-Medium;
    font-weight: 500;
    font-size: 36PX;
    line-height: 43PX;
    color: #414878;
    letter-spacing: 0;
    text-align: center;
}
</style>
